// Scroll the window to the top on every route navigation.
//
// Why: React Router preserves scroll position by default. When users click
// a card / link that navigates to a new page, they expect to land at the top
// of the new page, not wherever they were on the previous one.
//
// Notes:
//   - Anchor navigation (URLs with a `#hash`) is left alone — the browser
//     handles those.
//   - Uses `instant` to avoid a confusing animated jump between pages.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let in-page anchor jumps work normally
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
